import { controllerModelLib } from './lib';

const BOTTOM_SHEET_CONTROLLER_SYMBOL = 'bottom-sheet-controller';
const MODAL_CONTROLLER_SYMBOL = 'modal-controller';

export const injectionSymbols = {
  MODAL_CONTROLLER_SYMBOL,
  BOTTOM_SHEET_CONTROLLER_SYMBOL,
};

export const ModalPlugin = controllerModelLib.getPlugin(
  'modal-controller-plugin',
);
export const BottomSheetPlugin = controllerModelLib.getPlugin(
  'bottom-sheet-controller-plugin',
);
